exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3wJWAt7IqjnHGmGggR7AZd{height:100%;margin:38px 0px 40px 0px;display:flex;flex-direction:column}.vKerL_QQtSgBhKJHoKPBX{height:500px;display:flex;align-items:center;justify-content:center;flex-direction:column;color:#9e9e9e}._2DGpNhJLKujwsvZsHtAMeH{padding-top:16px}._1-NlI7bjZ9M1BMEZKMrf-F{opacity:0.6;font-size:13px;padding-bottom:15px}.w_R0J36fMfcGS6rXS_f9o{padding-bottom:10px}.E-4uzto-yX2M0t2MzOZjO{font-size:15px;margin-bottom:20px}.E-4uzto-yX2M0t2MzOZjO._3dLZ7K7hjUqFS2dPw8RLCV{margin-bottom:0px}.E-4uzto-yX2M0t2MzOZjO form{display:flex;align-items:flex-start}.E-4uzto-yX2M0t2MzOZjO form input{flex-grow:1;min-width:0px;height:42px;margin:0px}.E-4uzto-yX2M0t2MzOZjO form>button{margin:0px 0px 0px 20px}\n", ""]);

// Exports
exports.locals = {
	"EditorColumn": "_3wJWAt7IqjnHGmGggR7AZd",
	"emptyEditor": "vKerL_QQtSgBhKJHoKPBX",
	"editorCard": "_2DGpNhJLKujwsvZsHtAMeH",
	"savedAt": "_1-NlI7bjZ9M1BMEZKMrf-F",
	"title": "w_R0J36fMfcGS6rXS_f9o",
	"guideTitle": "E-4uzto-yX2M0t2MzOZjO",
	"header": "_3dLZ7K7hjUqFS2dPw8RLCV"
};